import React from 'react';
import {
  ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer,
} from 'recharts';

/**
 * Stacked bar breakdown + an optional overlaid line (total or an index like DSI),
 * generalizing the Campaign dashboard's BugsByDimensionChart for reuse across
 * Production Incident / Support / EPD / DSI breakdowns.
 *
 * Props:
 *   data         — array of rows, each with `dimensionKey` and one field per series.key
 *   dimensionKey — string, the x-axis field name
 *   series       — [{ key, name, color }] stacked bars
 *   line         — { key, name, color } | undefined — optional overlaid line on a secondary axis
 *   height       — number
 */
function StackedTrendChart({ data, dimensionKey, series, line, height = 220 }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <ComposedChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 50 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey={dimensionKey}
          tick={{ fontSize: 11 }}
          angle={-30}
          textAnchor="end"
          interval={0}
        />
        <YAxis yAxisId="left" />
        {line && <YAxis yAxisId="right" orientation="right" />}
        <Tooltip />
        <Legend verticalAlign="top" wrapperStyle={{ fontSize: 12 }} />
        {series.map(s => (
          <Bar key={s.key} yAxisId="left" dataKey={s.key} stackId="stack" fill={s.color} name={s.name} />
        ))}
        {line && (
          <Line
            yAxisId="right"
            dataKey={line.key}
            type="monotone"
            stroke={line.color}
            strokeWidth={2}
            dot={{ r: 3 }}
            name={line.name}
          />
        )}
      </ComposedChart>
    </ResponsiveContainer>
  );
}

export default StackedTrendChart;
